import React from 'react'
import "../Modules/valueprop.css";
import Navbar from './Navbar';
import Contact from './Contact';

const Products = () => {
  return (
    <>
    <div className="bg-dark fixed-top">
    <Navbar/>
    </div> <br />
     <section className='gainSection'> <br />
     <h2 className='ourMissionHeading' style={{color: 'white',marginTop:'5px',marginBottom:'5px',textAlign:'center'}}>Our Products</h2>
          <div className="container-fluid">
            <div className='innerOurMissionSection'>
                  <h2 className='ourMissionHeading wow animate__animated animate__zoomIn'>The Three Branches of Food Supply Vision:</h2>
                  <div>
                    <center>
                    <img src="ojaami.jpeg" alt="ojaami's logo" style={{height:'100px', width:'200px'}} />
                    </center>
                    <ul>
                      <li>
                      <h5>
                         Ojaami: The E-Commerce Platform for Fresh and Affordable Groceries
                      </h5>
                      </li>
                        <p style={{textAlign:'justify'}}>Ojaami is the e-commerce branch of Food Supply Vision, designed to offer consumers an easy
                        and affordable way to shop for fresh, high-quality farm products. Ojaami curates a variety of
                        farm produce sourced directly from farms and trusted suppliers, ensuring that every product
                        meets quality standards. With a focus on convenience, Ojaami is committed to making online
                        grocery shopping as straightforward as possible. Shoppers can browse through a wide selection
                        of products, place orders, and receive deliveries directly at their doorstep, all while benefiting
                        from competitive pricing and consistent quality.</p> <br />


                        <li>
                      <h5>
                        Green Grow: The Farm Rooted in Quality and Sustainability
                      </h5>
                      </li>
                        <p style={{textAlign:'justify'}}>Green Grow is Food Supply Vision’s agricultural backbone. It’s a farm dedicated to cultivating
                        high-quality crops and produce, managed with modern, sustainable farming practices to ensure
                        consistent output. Green Grow not only supplies fresh produce to Ojaami but will also support
                        broader agricultural goals by producing raw materials for processing into finished goods.
                        Through advanced farming techniques, Green Grow ensures a steady supply of vegetables, fruits,
                        grains, and more, maintaining an emphasis on freshness. By controlling this critical part of the
                        supply chain, Food Supply Vision can guarantee both the quality and traceability of its products
                        from farm to table.</p> <br />


                        <li>
                      <h5>
                        Fresh Flow: The Transportation Solution for Seamless Deliveries
                      </h5>
                      </li>
                        <p style={{textAlign:'justify'}}>Fresh Flow tackles one of the most challenging aspects of the food supply chain: transportation.
                        As a logistics and transport arm, Fresh Flow will provide a reliable system to move goods
                        efficiently from farms to the marketplace and ultimately to consumers’ doors. Fresh Flow’s
                        approach will reduce food wastage caused by transport delays and bring peace of mind to
                        customers.</p> <br />
                    </ul>
                   
                  </div>
            </div>
          </div>
        </section>


        <section className='aboutSection'>
          <div className="container-fluid">
            <div className='innerOurMissionSection'>
                  <h2 className='ourMissionHeading' style={{textAlign:'center'}}>Our Products</h2> <br />
                  <div className="mainBlueColor wow animate__animated animate__zoomIn leftTextAlign">
                    <ul>
                      <li>All kinds of Green leafy Vegetables</li>
                      <li>Tomatoes</li>
                      <li>Scotch Bonnet (Rodo)</li>
                      <li>Red bell pepper (Tatase)</li>
                      <li>Rice: Long and short grains</li>
                      <li>Beans ( Red, Brown and white varieties)</li>
                      <li>Onions</li>
                      <li>Yam flour (Elubo)</li>
                      <li>Yam</li>
                      <li>Semovita</li>
                      <li>Wheat</li>
                      <li>Plantain</li>
                      <li>Locust beans (iru)</li>
                    </ul>
                    </div> <br />
                  <div >
                    
                  </div>
                  <h2 className='ourMissionHeading' style={{textAlign:'center'}}>Target Market</h2> <br />
                  <ul>
                    <li>
                    <h5 className="text-success">Primary Market</h5>
                    </li >
                      <p style={{textAlign:'justify'}}>
                    Home Shoppers: Individuals who purchase goods or services from the comfort of their home,
                    typically using online platforms, catalogs, television shopping networks, or phone orders.
                      </p>
                    <br />
                    <li>
                      <h5 className="text-success">Secondary Market</h5></li>
                      <p style={{textAlign:'justify'}}>
                    Shop Owners: Individuals who own and manage a retail business, either online or in a physical
                    location. They are responsible for sourcing products, managing inventory, overseeing operations,
                    handling finances, and providing customer service.
                      </p>
                  </ul>
            </div>
          </div>
        </section>
        <Contact/>
    </>
  )
}

export default Products;